
import { Vue, Component, Prop } from "vue-property-decorator";
import AppIcon from "./AppIcon.vue";

@Component({
  components: {
    AppIcon,
  },
})
export default class AppSidebar extends Vue {
  @Prop({
    default: true,
  })
  public readonly mini!: boolean;

  public readonly NAVIGATION_LINKS = [
    {
      title: "Users",
      icon: "group",
      to: "UsersIndex",
    },
    {
      title: "Applications",
      icon: "application",
      to: "ApplicationsIndex",
    },
  ];

  constructor() {
    super();

    this.NAVIGATION_LINKS.push({
      title: "Identity Providers",
      icon: "privacy",
      to: "IdentityProvidersIndex",
    });
  }
}
